import $ from 'jquery';
import dialogPolyfill from 'dialog-polyfill';

export default function() {

	let dialog = document.getElementById('circlemodal-signup');
	dialogPolyfill.registerDialog(dialog);

	$(document.body).on('click', '.joinlink', function(e){
		e.preventDefault();
		dialog.showModal();
	});

	$(document.body).on('click', '#circlemodal-signup .close', function(e){
		e.preventDefault();
		dialog.close();
	});
}


// WEBPACK FOOTER //
// ./scripts/util/join.js